import React, { useEffect, useState } from "react";
import BasicInfo from "./sections/BasicInfo/BasicInfo";
import RequirementInfo from "./sections/RequirementInfo/RequirementInfo";
import JobDescription from "./sections/JobDescription/JobDescription";
import ModeOfRecruitment from "./sections/ModeOfRequirement/ModeOfRequirement";
import Terms from "./sections/Terms/Terms";
import Notes from "./sections/Notes/Notes";
import { useDispatch } from "react-redux";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { axios } from "../../../../../../../Global";
import { setAppError } from "../../../../../../../store/userSlice";
import { CgSpinner } from "react-icons/cg";
import LoadingWithLable from "./../../../../../../../ReusableComponents/Loading/LoadingWithLable";

export default function JobEnquiryEdit({ jobEnquiryId }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [submitFormLoading, setSubmitFormLoading] = useState(false);
  const token = localStorage.getItem("token");
  const [initialState, setInitialState] = useState("");
  const [initialStateLoading, setInitialStateLoading] = useState(true);

  const JobEnquiryInputValue = useOutletContext()[0];
  const toggleJobEnquiryUpdate = useOutletContext()[1];
  const nationality_data = JobEnquiryInputValue?.nationality;

  const [data, setData] = useState({});

  const [updateJobEnquiry, setUpdateJobEnquiry] = useState(false);

  useEffect(() => {
    try {
      axios
        .get(`/dashboard/project-job-enquiry/${jobEnquiryId},`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          setInitialStateLoading(false);
          setInitialState(response.data.data.job_enquiry);
        })
        .catch((error) => {
          setInitialStateLoading(false);
          dispatch(
            setAppError({
              msg: error?.response?.data?.message || error?.message,
            })
          );
        });
    } catch (error) {
      setInitialStateLoading(false);

      dispatch(
        setAppError({ msg: error?.response?.data?.message || error?.message })
      );
    }
  }, [updateJobEnquiry]);

  const handleSubmit = async (requirementInfoOnly) => {
    console.log(data, "final data after editing");

    if (!requirementInfoOnly) {
      setSubmitFormLoading(true);
      if (data?.v_benefit == "YES" && data?.v_benefit_value == "") {
        setSubmitFormLoading(false);
        dispatch(setAppError({ msg: "Provide vbenefit cost" }));
        return;
      }
      if (data?.v_cost == "YES" && data?.v_cost_value == "") {
        setSubmitFormLoading(false);
        dispatch(setAppError({ msg: "Provide vcost" }));
        return;
      }
      if (String(data?.nationality_id)?.trim() == "") {
        setSubmitFormLoading(false);
        dispatch(setAppError({ msg: "Please select a nationality" }));
        return;
      }
      if (data?.notes?.length == 0) {
        setSubmitFormLoading(false);
        dispatch(setAppError({ msg: "Atleast one note is needed." }));
        return;
      }
      if (data?.terms_and_conditions?.length == 0) {
        setSubmitFormLoading(false);
        dispatch(
          setAppError({ msg: "Atleast one terms and conditions is needed." })
        );
        return;
      }
    }
    let body = {};
    if (requirementInfoOnly) {
      body.cost_sheet_edit = data?.cost_sheet_edit;
      body.cost_sheet_new = data?.cost_sheet_new;
    } else {
      body = { ...data };
    }
    if (body?.v_benefit == "NO") delete body?.v_benefit_value;
    if (body?.v_cost == "NO") delete body?.v_cost_value;
    const emptyArrayToDelete = [];
    for (const key in body) {
      if (Array.isArray(body[key]) && body[key].length === 0) {
        emptyArrayToDelete.push(key);
      }
    }

    emptyArrayToDelete.forEach((key) => delete body[key]);
    try {
      const response = await axios.put(
        `/dashboard/project-job-enquiry/${jobEnquiryId}`,
        body,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status == 200) {
        if (!requirementInfoOnly) {
          setSubmitFormLoading(false);
          toggleJobEnquiryUpdate();
          dispatch(
            setAppError({ msg: response.data.message, color: "success" })
          );
          navigate(-1);
        }
      }
    } catch (error) {
      if (!requirementInfoOnly) {
        setSubmitFormLoading(false);
        dispatch(
          setAppError({ msg: error?.response?.data?.message || error?.message })
        );
      }
    }
  };

  return (
    <>
      <div className="w-full flex flex-wrap gap-4 justify-between items-center p-5 ">
        <div className="flex gap-16">
          <h1 className="font-semibold text-xl">Job Enquiry Edit</h1>
        </div>
      </div>
      {initialStateLoading ? (
        <div className="w-full flex justify-center">
          <LoadingWithLable />
        </div>
      ) : (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <div className="w-full flex flex-col gap-7">
            <BasicInfo
              setData={setData}
              initialState={initialState}
              nationality_data={nationality_data}
            />
            <RequirementInfo
              setData={setData}
              initialState={initialState}
              updateJobEnquiry={updateJobEnquiry}
              setUpdateJobEnquiry={setUpdateJobEnquiry}
              jobEnquiryId={jobEnquiryId}
              handleJobEnquiryEdit={handleSubmit}
              vBenefit={data?.v_benefit}
              vBenefitValue={data?.v_benefit_value}
            />
            <JobDescription setData={setData} initialState={initialState} />
            <ModeOfRecruitment setData={setData} initialState={initialState} />
            <Terms setData={setData} initialState={initialState} />
            <Notes setData={setData} initialState={initialState} />
          </div>
          <div className="w-full p-4 mt-6 flex flex-wrap justify-center gap-4">
            <button
              type="button"
              className="w-full max-w-xs p-2 px-6 ring-1 ring-slate-200 rounded-md"
              onClick={() => navigate("")}
            >
              Cancel
            </button>
            <button
              className="w-full max-w-xs p-2 px-6 ring-1 ring-slate-200 rounded-md bg-red text-white"
              type="submit"
              disabled={submitFormLoading}
            >
              {submitFormLoading ? (
                <CgSpinner className="animate-spin mx-auto" />
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </form>
      )}
    </>
  );
}
